import { useIsNextMorning } from "@/components/features/items/edit/option/_shared/ui/components/is-next-morning/hooks";

import { useProductOptionFormModelContext } from "../../../../context";

export const useOptionIsNextMorning = () => {
	const { viewModel, onSetViewModel } = useProductOptionFormModelContext();
	const { isNextMorning, useAsSubOption } = viewModel;

	return useIsNextMorning({ isNextMorning, onSetViewModel, useAsSubOption });
};
